import React from "react";
import { FlaskConical } from "lucide-react";

/**
 * SpecBadge — unified marker for specification / read-only pages.
 * Pages that describe capabilities without executing them must render this
 * near their title so they are never mistaken for operational surfaces.
 */
const SpecBadge = ({ label = "مواصفة — قراءة فقط", description, className = "" }) => (
  <span
    title={description}
    className={`inline-flex items-center gap-1.5 rounded-full border border-warning-300 bg-warning-50 px-3 py-1 text-xs font-semibold text-warning-800 dark:border-warning-800 dark:bg-warning-950/40 dark:text-warning-300 ${className}`}
    data-testid="spec-badge"
  >
    <FlaskConical size={13} aria-hidden="true" />
    {label}
  </span>
);

export default SpecBadge;
